module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vdige3-973bc5d6e4eedcabe29be47808130ecb.jpg";